<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                Nit cliente
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <div class="contenedor_nombre_cliente">
                            {{ nombre_cliente }}
                        </div>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="campo_nit_solicitud" class="form-label">NIT</label>
                        <input type="text" id="campo_nit_solicitud" autocomplete="off"
                            class="form-control form-control-sm" v-model="nit" @keydown.enter="buscar_nit">
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">

                        <button v-if="nit != '' && nombre_cliente == ''" type="button"
                            class="btn btn-sm btn-outline-dark btn-block" @click="buscar_nit">Buscar</button>
                        <button v-if="nit != '' && nombre_cliente != ''" type="button"
                            class="btn btn-sm btn-outline-dark btn-block" @click="guardar_info">Guardar</button>

                    </div>
                </b-row>
            </b-container>
        </div>
        <Cargando v-if="loading_nit" :titulo="'Buscando...'" />
    </div>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex'
    import Cargando from '@/components/Loading/Cargando.vue'
    import { atexto } from '../functions/alertas'

    export default {
        name: 'SolicitarNit',
        components: {
            Cargando
        },
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario']),

        },
        data() {
            return {
                nombre_cliente: '',
                nombre_cliente_seteado: '',
                nit: '',
                nit_seteado: '',
                loading_nit: false,
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir_modal_nit')
            },
            async buscar_nit() {
                if (this.nit.trim() == '' || this.nit.trim().toLowerCase() == 'cf') {
                    this.nit = 'CF'
                    this.nit_seteado = 'CF'
                    this.nombre_cliente = 'Consumidor Final'
                    this.nombre_cliente_seteado = 'Consumidor Final'
                } else {
                    let f = {
                        api: `consultas-fels/c/nit?nit=${this.nit}&empresa=${this.id_empresa_seleccionada}`
                    }

                    this.loading_nit = true
                    let r = await this.obtener_data(f)
                    this.loading_nit = false

                    if (r.respuesta === true) {
                        this.nit = this.nit
                        this.nit_seteado = this.nit
                        this.nombre_cliente = r.nombres + ' ' + r.apellidos
                        this.nombre_cliente_seteado = r.nombres + ' ' + r.apellidos
                    } else {
                        this.nit_seteado = ''
                        this.nombre_cliente = ''
                        this.nombre_cliente_seteado = ''

                        atexto({
                            titulo: 'Algo salió mal!',
                            cuerpo: r.nombres,
                            icono: 'warning'
                        })
                    }
                }
            },
            limpiar_info() {
                this.nit = ''
                this.nit_seteado = ''
                this.nombre_cliente = ''
                this.nombre_cliente_seteado = ''
            },
            guardar_info() {
                this.set_datos_cliente({
                    nit: this.nit_seteado,
                    nombre_cliente: this.nombre_cliente_seteado
                })
                this.cerrar()
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_datos_cliente'])
        },
        mounted() {
            document.getElementById('campo_nit_solicitud').focus()
        },
        watch: {
            nit() {
                if (this.nit.trim() == '') {
                    this.limpiar_info()
                }
            }
        }
    }
</script>

<style>
    .contenedor_nombre_cliente {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
    }
</style>